import Link from "next/link";
import Image from "next/image";
import { HERO_CONFIG } from "@/data/hero";

export function Logo() {
  return (
    <Link href="/" className="relative z-10 transition-opacity duration-200 hover:opacity-80">
      <Image
        src={HERO_CONFIG.logo.src}
        alt={HERO_CONFIG.logo.alt}
        width={160} // adjust to your logo size
        height={50}
        priority
      />
    </Link>
  );
}